import React from 'react'
import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import messages from '../../../messages'
import { semiConfigContext } from '../Crisprgna'
import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => {
  return {
    lightGreyFont: {
      padding: theme.spacing(3.5, 0, 3.5),
      fontSize: theme.typography.pxToRem(15),
    },
  }
})

const ControlsResultSet = () => {
  const classes = useStyles()
  const { state } = React.useContext(semiConfigContext)
  const perPage = state.searchValue.count
  const totalCount = state.paginationData.controlItemsCount
  const page = 1

  return (
    <div>
      <Grid className={classes.lightGreyFont}>
        <FormattedMessage
          {...messages.SEMICONF_PAGINATION_SHOWING_TEXT_crisprgrna}
        />{' '}
        {totalCount > 0 ? (page - 1) * perPage + 1 : 0} -{' '}
        {totalCount > page * perPage ? page * perPage : totalCount}{' '}
        <FormattedMessage
          {...messages.SEMICONF_PAGINATION_OF_TEXT_crisprgrna}
        />{' '}
        {totalCount}{' '}
        <FormattedMessage
          {...messages.SEMICONF_PAGINATION_RESULTS_TEXT_crisprgrna}
        />
      </Grid>
    </div>
  )
}

export default ControlsResultSet
